import script from "./WorkAndCostCenter.vue?vue&type=script&lang=ts&setup=true"
export * from "./WorkAndCostCenter.vue?vue&type=script&lang=ts&setup=true"

import "./WorkAndCostCenter.vue?vue&type=style&index=0&id=0aaca06a&lang=css"

const __exports__ = script;

export default __exports__